// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';

const wiz = new Wiz({ appId: 'layout.empty', namespace: 'empty' });
@AngularComponent({
  selector: 'wiz-layout-empty',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class LayoutEmptyComponent {}

export default LayoutEmptyComponent;
